/* eslint-disable react/forbid-prop-types */
import React from "react";

import PropTypes from "prop-types";

function EditParcelZoneCard(props) {
  const {
    searchedParcel,
    deleteParcelFromRequest,
    zoneEditParcelZoom,
    toggleDialog,
  } = props;
  return (
    <div key={searchedParcel.OBJECTID} className="parcel_change_request mt-3">
      <div className="parcel_change_request__row--1">
        <p>
          <span className="text-bold">رقم القطعة:</span>{" "}
          {searchedParcel.PARCEL_ID}
        </p>
        <div className="parcel_change_request__actions">
          {deleteParcelFromRequest && (
            <button
              type="button"
              className="employee-requests__card__action badge badge--red"
              onClick={deleteParcelFromRequest.bind(this, searchedParcel)}
            >
              <i className="fa-solid fa-trash-can" />
            </button>
          )}
          <button
            type="button"
            className="employee-requests__card__action badge badge--blue"
            onClick={zoneEditParcelZoom.bind(this, searchedParcel)}
          >
            <i className="fa-solid fa-location-dot" />
          </button>
        </div>
      </div>
      <div className="parcel_change_request__row--2">
        <p>
          <span className="text-bold">صفة الاستعمال:</span>{" "}
          {searchedParcel.ZONE_IDName}
        </p>
      </div>
      <div className="parcel_change_request__row--3">
        <button
          type="button"
          className="btn btn--primary--light w-100"
          onClick={toggleDialog.bind(this, searchedParcel)}
        >
          تفاصيل صفة الإستعمال
        </button>
      </div>
    </div>
  );
}

EditParcelZoneCard.defaultProps = {
  deleteParcelFromRequest: null,
};

EditParcelZoneCard.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  searchedParcel: PropTypes.object.isRequired,
  deleteParcelFromRequest: PropTypes.func,
  zoneEditParcelZoom: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
};

export default EditParcelZoneCard;
